import { render, staticRenderFns } from "./AdminRequestByStatusApproved.vue?vue&type=template&id=0c568271&scoped=true&"
import script from "./AdminRequestByStatusApproved.vue?vue&type=script&lang=js&"
export * from "./AdminRequestByStatusApproved.vue?vue&type=script&lang=js&"
import style0 from "./AdminRequestByStatusApproved.vue?vue&type=style&index=0&id=0c568271&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c568271",
  null
  
)

export default component.exports